<template>

  <div ref="docCard" @click="click" :class="cardClass+' '+fullStyle" :style="'width:'+(docWidth+10)+'px; height:'+(docHeight+100)+'px'">
    <div class="drag cardTitle"><span :class="isNew" style="pointer-events:none;">{{document.name}}</span></div>
     <DocScanner ref="docScan" v-if="document"  :mapVis="mapVis" @showMap="showMap" :active="fullSize" :document="document" :width="docWidth" :height="docHeight" :style="style" ></DocScanner>
    <slot></slot>
    <div style="bottom:10px;position:absolute;width:100%;text-align: center;">
   <div v-if="!fullSize" @click="viewDoc" :class="'basicBtn '+isNew" >View Document</div>
   <div v-else>
     
     <div @click="viewDoc" class="basicBtn">Close Document</div>
     </div>
   </div>
   <ConnectedElement v-if="fullSize && mapVis" :pos="{x:530,y:0}"  :anchor="{x:697,y:66}" :resize="true" :resizing="resizeMap" :dragHandle="'.dragMap'" :isActive="isActive" :width="600" :height="400">
       <MapPanel @hideMap="hideMap" ref="mapPanel" class="floatingMap" :width="docWidth" style="height:100%; width:100%;" @activateMap="isActive=!isActive"></MapPanel>
    </ConnectedElement>
 
  </div>
</template>

<script>

 

import DocScanner from "@/components/DocScanner.vue";

import ConnectedElement from "@/components/ConnectedElement.vue"
import MapPanel from "@/components/MapPanel.vue";
export default {
  components:{
  
   DocScanner,
   MapPanel,
   ConnectedElement
 
  },
  props: {
    cardClass:{default:"expertCard"},
    card:null,
    index:null,
    resizeCallback:null,
    selected:{default:false}
  },
  data() {
    return {
      fullSize:false,
       mapVis:false,
       isActive:true,
       style:"position:absolute;left:0px;opacity:.9;border:none;text-transform: uppercase;margin-auto"
  
    };
  },
  computed: {
    viewedDocs(){
      return this.$store.getters.getViewedDocs
      
    },
    isNew(){
      if(this.viewedDocs.includes(this.card.id)){
        this.card.read=true
      }
     // console.log("IS NEW",this.viewedDocs,this.card.id)
     if(!this.card.read ){
       return "unread" 
     }
    },
    windowHeight(){
      return window.innerHeight-160
    },
    windowWidth(){
      return window.innerWidth-100
    },
    docRatio(){
      if(this.docSize){
        return this.docSize.width/this.docSize.height
      }
      return this.document.ratio || 1.6
    },
    docScale(){
      let sh=this.windowHeight/this.docSize.height
      let sw=this.windowWidth/this.docSize.width
      return Math.min(sh,sw)
    },
    docSize(){
      if(this.document["image-size"]){
        let docSize=this.document["image-size"].split(",")
        if(docSize.length==2){
          return {width:parseInt(docSize[0]),height:parseInt(docSize[1])}
        }
      }
      return {width:600,height:800}
    },
    docWidth(){
      
      if(this.fullSize){
        return this.docSize.width*this.docScale
      }else{
        return 203
      }
    },
    docHeight(){
      if(this.fullSize){
       return Math.floor(this.docWidth/this.docRatio)
      }else{
        return 204
      }
    },
    fullStyle(){
      if(this.fullSize){
        return " fullSize"
      }else{
        return ""
      }
    },
   document(){
     return this.$store.getters.getDocument(this.card.id)
   }
  },
  methods: {
    resizeMap(){
      this.$refs.mapPanel.doResize()
    },
    showMap(){
      this.mapVis=true;
    },
    hideMap(){
      this.mapVis=false;
    },
    viewDoc(){
      this.fullSize=!this.fullSize
      if(!this.fullSize){
        this.$refs.docScan.doZoomOut()
      }
    },
    click(){
      
      this.$emit('click',this.index)
    }
  },
  watch:{
    fullSize(val){
     
      this.$emit('click',this.index)
      this.$set(this.card,'width',this.docWidth)
      this.$set(this.card,'height',this.docHeight)
      this.$set(this.document,'read',true)
      console.log("READ",this.document)
      this.$store.commit('readDoc',this.document)
        this.$set(this.card,'read',true)
      //this.$emit("resizeCard")
      if(val){
          let docMidX=this.$refs.docCard.getBoundingClientRect().left+this.docWidth/2
          let docMidY=this.$refs.docCard.getBoundingClientRect().top+this.docHeight/2
          this.$emit("moveCardLeft",-(this.windowWidth/2-docMidX+25))
          this.$emit("moveCardTop",-(this.windowHeight/2-docMidY)-20) 
      }else{
         this.$emit("resetCardPos")
      }
     
      
      console.log(this.$refs.docCard.getBoundingClientRect().left)
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.documentCard {
  text-align: center;
  min-height: 240px!important;
  top:0px;
  left:8px;
  border: solid 3px #0bf;
  background-color: $glow-bg;
  box-shadow: inset 0px 0px 20px 0px;
  color: #0bf;
  line-height: 30px;
  margin:10px;
  
  position:relative;
  .unread{
      color:#0efb0c;
   }
}

  .drag{
    cursor:move;
    cursor:grab;
  }
  .drag:active {
     cursor:move;
    cursor: grabbing;
  }
.floatingMap{
  width:700px;
  border: solid 3px $glow-text-colour-selected;
}
.cardTitle{
  text-align:center;
  text-transform: uppercase;
    font-size: 17px;
    padding: 2px 5px;
}
.basicBtn{
  margin: auto;
    cursor: pointer;
    border: solid;
    width: 150px;
    border-radius: 5px;
    padding: 0px 5px;
    background-color:#0007;
}
.basicBtn:hover{
  background-color:#fff3;
}
</style>